import BaseTimePicker from 'components/atoms/base-timepicker';
import { DateFormats } from 'infrastructure/enums';
import { DateFormatter } from 'infrastructure/functions';
import PropTypes from 'prop-types';

const TimeInput = ({
  id,
  title,
  setValue,
  values,
  isRequired,
  requiredIf,
  helpText,
}) => {
  let required = isRequired;
  if (requiredIf) {
    required = isRequired || values[requiredIf.key] === requiredIf.value;
  }
  return (
    <div className="input-wrapper" data-cy={id}>
      <label htmlFor={id}>
        {title} {required && <span className="color-red">*</span>}
      </label>
      {helpText && <p className="help-text">{helpText}</p>}
      <BaseTimePicker
        className="time-input"
        format={DateFormats['HH:mm']}
        onChange={(date) => {
          setValue({
            [id]: DateFormatter({ date }),
          });
        }}
        value={values[id]}
      />
    </div>
  );
};

TimeInput.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  helpText: PropTypes.string,
  setValue: PropTypes.func,
  isRequired: PropTypes.bool,
  requiredIf: PropTypes.object,
  values: PropTypes.shape(),
};

export default TimeInput;
